module.exports = __webpack_public_path__ + "static/media/5J1A6640_Small.9d83436b.jpg";